import React, { Component } from 'react';
import Card from './Card';

class IndexTable extends Component {
    render(x)  {
return (
    <Card title={this.props.title} body={
        <table className="table" >
            <thead>
            <tr>
                <th>Marknad</th>
                <th>Index</th>
                <th>1 månad</th>
                <th>3 månader</th>
                <th>12 månader</th>
            </tr>
            </thead>
            <tbody>
            {this.props.tData.sort((a, b) => a.indexposition > b.indexposition ? 1 : -1).map(data =>
                <tr>
                    <td><h3 style={{fontWeight: data.bold === true ? '900' : 'normal'}}>{data.name}</h3></td>
                    <td><h3 style={{fontWeight: data.bold === true ? '900' : 'normal'}}>{data.annual_highest_value}</h3></td>
                    <td><h3 style={{color: data.recent_month_change < 0 ? '#f70000' : '#00f70d',fontWeight: data.bold === true ? '900' : 'normal'}}>{data.recent_month_change.toFixed(1)}%</h3></td>
                    <td><h3 style={{color: data.three_month_change < 0 ? '#f70000' : '#00f70d',fontWeight: data.bold === true ? '900' : 'normal'}}>{data.three_month_change.toFixed(1)}%</h3></td>
                    <td><h3 style={{color: data.twelve_month_change < 0 ? '#f70000' : '#00f70d',fontWeight: data.bold === true ? '900' : 'normal'}}>{data.twelve_month_change.toFixed(1)}%</h3></td>
                </tr>)
                }
            </tbody>
        </table>
    }
    ></Card>)
}
}

export default IndexTable;
